/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import { handleActions } from 'redux-actions';
import { playlist } from '@/config';
import { toPlayerTime } from '@/utils/time';
import { READY, SELECT_PLAYLIST_ENTRY } from '../../actions/types';

const INITIAL_STATE = null;

/**
 * Sets one episode in the redux store's playlist active and all the others inactive.
 *
 * @param {Array<Object>} state state of the store's "playlist" property
 * @param {number} payload index of the episode to activate (others will be deactivated)
 * @return the new state of "playlist"
 */
const active = (state, payload) => state.map((item, index) => ({ ...item, active: payload === index }));

export const reducer = handleActions(
  {
    [READY]: (state, { payload }) => state
      || playlist(payload).map(item => ({
        ...item,
        duration: toPlayerTime(item.duration),
        active: false,
      })),
    [SELECT_PLAYLIST_ENTRY]: (state, { payload: { index } }) => state && active(state, index),
  },
  INITIAL_STATE,
);
